import {createFeatureSelector} from "@ngrx/store";
import {UserState} from "./state";


export const selectUser = createFeatureSelector<UserState>('user');
